import { JobCareThemeType } from './theme';

export const scaleIconCard = (property: string, value: number, theme: JobCareThemeType) => {
  const size = Math.floor(value * theme.iconCard.scale);

  return `
    ${property}: ${size}px;
  `;
};
